import React from "react";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";

interface TwoLineCardSkeletonProps {
  cardsCount: number;
  baseColor: string;
  highlightColor: string;
}

const TwoLineCardSkeleton: React.FC<TwoLineCardSkeletonProps> = ({
  cardsCount,
  baseColor,
  highlightColor,
}) => {
  const arr = Array(cardsCount).fill(0);

  return (
    <>
      {arr.map((_, i) => (
        <div className="card-card-skeleton--two-line" key={i}>
          <h3>
            <Skeleton baseColor={baseColor} highlightColor={highlightColor} />
          </h3>
          <p>
            <Skeleton baseColor={baseColor} highlightColor={highlightColor} />
          </p>
        </div>
      ))}
    </>
  );
};

export default TwoLineCardSkeleton;
